/* eslint-disable */
import React from "react";
import {
  FormControl,
  FormLabel,
  HStack,
  Radio,
  RadioGroup, Select,
} from "@chakra-ui/react";
import {
  Button,
  Divider, InputLabel,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  FormControl as MuiFormControl,
} from "@material-ui/core";
import { Pagination, Skeleton } from "@material-ui/lab";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { show } from "redux-modal";
import { withTranslation } from "react-i18next";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
// core components
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import UserHeader from "../../components/Headers/UserHeader";
import {
  getTeam,
  editTeam,
  updateTeam,
  addUser,
  deleteUser,
} from "../../utils/store/actions/teams.actions";
import {
  editUser,
  getAllUsers,
  paginateUsers,
  getClientsFiltered,
} from "../../utils/store/actions/users.actions";

import { getAllFunds, getAllFundsInTeam, postFundInTeam, deleteFundInTeam } from "../../utils/store/actions/funds.actions";
import { SearchIcon } from "@chakra-ui/icons";
import Fund from "../Funds/Fund";
import Loader from "react-loader-spinner";
import LogoConfiguration from "./LogoConfiguration";

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: "transparent",
      maxWidth: "90%",
      margin: "auto",
      marginTop: "5%",
      boxShadow: "none",
    },
    searchList: {
      backgroundImage: `url(${Image}
    )` /* Add a search icon to input */,
      backgroundSize: "16px",
      backgroundPosition: "12px 12px" /* Position the search icon */,
      backgroundRepeat: "no-repeat" /* Do not repeat the icon image */,
      fontSize: "16px" /* Increase font-size */,
      padding: "12px 12px 12px 12px" /* Add some padding */,
      marginBottom: "10px",
      border: "1px solid #97A0C3",
      boxShadow: "0px 2px 4px rgba(28, 41, 90, 0.0367952)",
      borderRadius: "10px",
      color: "#97A0C3",
    },
    searchBar: {
      backgroundColor: "#F5F6FF",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    searchInput: {
      backgroundColor: "#F5F6FF",
      fontSize: theme.typography.fontSize,
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
    },
    contentWrapper: {
      margin: "40px 16px",
    },
    rootList: {
      maxHeight: 400,
      overflow: "scroll",
    },
    rootList2: {
      maxHeight: 450,
      overflow: "scroll",
    },
  });

class Team extends React.PureComponent<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      teamUsers: [],
      meUsers: [],
      userName: null,
      firstName: null,
      role: null,
      email: null,
      language: null,
      contact: null,
      about: null,
      searchFilter: "",
      inputValue: "",
    };
  }

  async componentWillMount() {
    const teamId = new URLSearchParams(window.location.search).get("id");
    await this.props.getTeam(teamId);
    this.setState({usersInTeam:this.props?.Teams?.team?.users})
    await this.props.getAllUsers();
    await this.props.getAllFunds("true");
    await this.props.getAllFundsInTeam(teamId).then(() =>
    this.setState({fundsInTeam:this.props?.Funds?.funds_in_team}))
  }

  editUser = (user: any) => {
    this.props.getUser(user.id);
    window.location.href = `/admin/user/?id=${user.id}`;
  };

  handleChange = (e: any) => {
    this.props.updateTeam(e.target.id, e.target.value, this.props.Teams.team);
  };

  handleChangeUsers = (e: any, value: any) => {
    this.setState({ load: !this.state.load });
    this.props.paginateUsers(value, this.state.searchFilter);
  };

  handleDeleteUser = async (userId: any, team: any) => {
    await this.props.deleteUser(userId, team);
    await this.props.getTeam(team.id);
    this.setState({usersInTeam:this.props?.Teams?.team?.users})
  };

  handleDeleteFund = async (teamId: string, fundId: string) => {
    await this.props.deleteFundInTeam(teamId, fundId);
    await this.props.getAllFundsInTeam(teamId);
    this.setState({fundsInTeam:this.props?.Funds?.funds_in_team})
  }

  handleChangeDefault = (e: any) => {
    this.props.getClientsFiltered(`name=${e.target.value}`);
    this.setState({ searchFilter: `name=${e.target.value}` });
    const userInput = e.currentTarget.value;

    this.setState({
      activeSuggestion: 0,
      showSuggestions: true,
      userInput: e.currentTarget.value,
    });
  };

  handleSearch(e: any) {
    this.setState({ inputValue: e.target.value });
  }

  async addFundInTeam(teamId: string, fundId: string) {
    await this.props.postFundInTeam(teamId, fundId)
    await this.props.getAllFundsInTeam(teamId);
    this.setState({fundsInTeam:this.props?.Funds?.funds_in_team})
  }

  async addUserInTeam(user:any, team:any) {
    await this.props.addUser(user, team);
    await this.props.getTeam(team.id);
    this.setState({usersInTeam:this.props?.Teams?.team?.users})
  }

  render() {
    const { team } = this.props.Teams;
    const { classes, Users, t, Funds } = this.props;
    return (
      <>
        {team && team.id !== "" ? (
          <Paper className={classes.paper}>
            <Row style={{ backgroundColor: "transparent" }}>
              {/* CENTER CONTENT */}
              <Col className="order-xl-1" xl="8">
                <Card className="bg-secondary shadow">
                  <CardHeader className="bg-white border-0">
                    <Row className="align-items-center">
                      <Col xs="8">
                        <h3 style={{ color: "#ae0064" }} className="mb-0">
                          {t("team")}: {team.name}
                        </h3>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <Form>
                      <h6 className="heading-small text-muted mb-4">
                        {t("TEAM_INFORMATION")}
                      </h6>

                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="name"
                              >
                                {t("NAME")}
                              </label>
                              <Input
                                className="form-control-alternative"
                                defaultValue={team.name}
                                disabled
                                onChange={(e: any) => this.handleChange(e)}
                                id="name"
                                placeholder="name"
                                type="text"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormControl id="role" isRequired>
                              <FormLabel>{t("INTERNAL")}</FormLabel>
                              <RadioGroup
                                defaultValue={team.internal ? "true" : "false"}
                              >
                                <HStack spacing="24px">
                                  <Radio disabled value="true">
                                    {t("YES")}
                                  </Radio>
                                  <Radio disabled value="false">
                                    {t("NO")}
                                  </Radio>
                                </HStack>
                              </RadioGroup>
                            </FormControl>
                          </Col>
                          <hr className="my-4" />
                        </Row>
                      <hr className="my-4" />
                      <Row >
                        <Col lg="12">
                          <InputLabel id="zones-label">{t('CHOOSE_ZONE')}</InputLabel>
                          <Select
                              labelId="zones-label"
                              name="distributionCountry"
                              id="distributionCountry"
                              value={team.distributionCountry}
                              onChange={(e: any) => this.handleChange(e)}
                              defaultValue={team.distributionCountry}>
                                {this.props.Users?.get_properties &&
                                    this.props.Users?.get_properties?.map((obj) => {
                                      return (
                                          obj.key === "GEOGRAPHICAL_ZONE" &&
                                          obj.values.map((country) => (
                                              <option key={country} value={country}>
                                                {
                                                  country
                                                    ? this.props.t("ENUMS.COUNTRIES." + country)
                                                    : ""
                                                }
                                              </option>
                                          ))
                                      );
                                    })}
                          </Select>
                        </Col>
                      </Row>
                      <hr className="my-4" />
                      <div
                        style={{ color: "#ae0064" }}
                        className="d-flex justify-content-between"
                      >
                        {t("LIST_OF_USERS_IN_TEAM")}
                      </div>
                      <hr className="my-4" />
                      <List className={classes.rootList2}>
                        <div className="drag-container">
                            {this.state.usersInTeam &&
                              this.state.usersInTeam !== [] &&
                              this.state.usersInTeam.map((user: any) => {
                                return (
                                  <div key={user.id} draggable>
                                    <ListItem>
                                      <ListItemAvatar>
                                        <AccountBoxIcon
                                          style={{ color: "#ae0064" }}
                                        />
                                      </ListItemAvatar>
                                      <ListItemText
                                        primary={
                                          <div className={classes.truncate}>
                                            <strong>
                                              {user ? user.name : "Anonymous"}
                                            </strong>{" "}
                                            {user.firstName}
                                          </div>
                                        }
                                        secondary={user.email}
                                      />
                                      <Button
                                        onClick={() =>
                                          this.handleDeleteUser(user.id, team)
                                        }
                                        color="secondary"
                                        style={{ textTransform: "none" }}
                                      >
                                        {t("REMOVE")}
                                      </Button>
                                    </ListItem>
                                    <Divider />
                                  </div>
                                );
                              })}
                        </div>
                      </List>
                      <hr className="my-4" />
                      <div
                        style={{ color: "#ae0064" }}
                        className="d-flex justify-content-between"
                      >
                        {t("LIST_OF_FUNDS_IN_TEAM")}
                      </div>
                      <hr className="my-4" />
                      <List className={classes.rootList2}>
                        <div className="drag-container">
                          {this.state.fundsInTeam &&
                            this.state.fundsInTeam !== [] &&
                            this.state.fundsInTeam.map((fund: any) => {
                              return (
                                <div key={fund.id} draggable>
                                  <ListItem>
                                    <ListItemAvatar>
                                      <AccountBoxIcon
                                        style={{ color: "#ae0064" }}
                                      />
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={
                                        <div className={classes.truncate}>
                                          <strong>
                                            {fund ? fund.person?.name : "Anonymous"}
                                          </strong>{" "}
                                        </div>
                                      }
                                    />
                                    <Button
                                      onClick={() =>
                                        this.handleDeleteFund(team.id, fund.id)
                                      }
                                      color="secondary"
                                      style={{ textTransform: "none" }}
                                    >
                                      {t("REMOVE")}
                                    </Button>
                                  </ListItem>
                                  <Divider />
                                </div>
                              );
                            })}
                        </div>
                      </List>
                    </Form>
                    <LogoConfiguration teamId={team.id} />
                  </CardBody>
                </Card>
              </Col>
              {/* available users  */}
              <Col
                className="order-xl-2 mb-5 mb-xl-0"
                xl="4"
                style={{ backgroundColor: "transparent", marginTop: "10px" }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Card style={{ margin: "12px" }}>
                    <Row className="justify-content-center">
                      <Col className="order-lg-2" lg="3">
                        <div className="card-profile-image">
                          <a
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          ></a>
                        </div>
                      </Col>
                    </Row>
                    <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                      <div
                        style={{ color: "#ae0064" }}
                        className="d-flex justify-content-between"
                      >
                        {t("USERS_LIST")}
                      </div>
                    </CardHeader>
                    <CardBody className="pt-0 pt-md-4">
                      <input
                        style={{ width: "-webkit-fill-available" }}
                        type="text"
                        className={classes.searchList}
                        id="myInputUser"
                        onChange={(e) => this.handleChangeDefault(e)}
                        placeholder={t("SEARCH")}
                      />
                      <List className={classes.rootList}>
                        <div className="drag-container">
                            {Users &&
                              Users.List !== [] &&
                              Users.List.content.map((user: any) => {
                                return (
                                  <div key={user.id} draggable>
                                    <ListItem>
                                      <ListItemAvatar>
                                        <AccountBoxIcon
                                          style={{ color: "#ae0064" }}
                                        />
                                      </ListItemAvatar>
                                      <ListItemText
                                        primary={
                                          <div className={classes.truncate}>
                                            <strong>
                                              {user ? user.name : "Anonymous"}
                                            </strong>{" "}
                                            {user.firstName}
                                          </div>
                                        }
                                        secondary={user.email}
                                      />
                                      <Button
                                        onClick={() =>
                                          this.addUserInTeam(user, team)
                                        }
                                        style={{
                                          color: "#ae0064",
                                          textTransform: "none",
                                        }}
                                      >
                                        {t("ADD")}
                                      </Button>
                                    </ListItem>
                                    <Divider />
                                  </div>
                                );
                              })}
                        </div>
                      </List>
                      <Pagination
                        count={Users.List.totalPages}
                        page={Users.List.number + 1}
                        onChange={this.handleChangeUsers}
                      />
                    </CardBody>
                  </Card>
                  {/* available funds  */}
                  <Card style={{ margin: "12px" }}>
                    <Row className="justify-content-center">
                      <Col className="order-lg-2" lg="3">
                        <div className="card-profile-image">
                          <a
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          ></a>
                        </div>
                      </Col>
                    </Row>
                    <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                      <div
                        style={{ color: "#ae0064" }}
                        className="d-flex justify-content-between"
                      >
                        {t("FUNDS_LIST")}
                      </div>
                    </CardHeader>
                    <CardBody className="pt-0 pt-md-4">
                      <input
                        style={{ width: "-webkit-fill-available" }}
                        type="text"
                        className={classes.searchList}
                        id="myInput"
                        value={this.state.inputValue}
                        onChange={(e: any) => this.handleSearch(e)}
                        placeholder={t("SEARCH")}
                      />
                      <List className={classes.rootList}>
                        <div className="drag-container">
                          {Funds &&
                            Funds.funds_list &&
                            (Funds.funds_list || [])
                              ?.filter((obj: any) =>
                                obj.name
                                  .toLowerCase()
                                  .includes(this.state.inputValue.toLowerCase())
                              )
                              .map((fund: any) => {
                                return (
                                  <div key={fund.id} draggable>
                                    <ListItem>
                                      <ListItemAvatar>
                                        <AccountBoxIcon
                                          style={{ color: "#ae0064" }}
                                        />
                                      </ListItemAvatar>
                                      <ListItemText
                                        primary={
                                          <div className={classes.truncate}>
                                            <strong>
                                              {fund ? fund.name : "Anonymous"}
                                            </strong>{" "}
                                          </div>
                                        }
                                      />
                                      <Button
                                        onClick={() =>
                                         this.addFundInTeam(team.id, fund.id)
                                        }
                                        style={{
                                          color: "#ae0064",
                                          textTransform: "none",
                                        }}
                                      >
                                        {t("ADD")}
                                      </Button>
                                    </ListItem>
                                    <Divider />
                                  </div>
                                );
                              })}
                        </div>
                      </List>
                    </CardBody>
                  </Card>
                </div>
              </Col>
            </Row>
          </Paper>
        ) : (
          <Skeleton variant="rect" width={"100%"} height={"72vh"} />
        )}
      </>
    );
  }
}

const mapStateToProps = (state: {
  Teams: TeamsState;
  Users: UsersState;
  Funds: FundsState;
}) => ({
  Teams: state.Teams,
  Users: state.Users,
  Funds: state.Funds,
});

const mapDispatchToProps = {
  getTeam,
  editTeam,
  updateTeam,
  editUser,
  addUser,
  deleteUser,
  getAllUsers,
  paginateUsers,
  getClientsFiltered,
  getAllFunds,
  getAllFundsInTeam,
  postFundInTeam,
  deleteFundInTeam,
  show,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(Team)));
